import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sr-only loadingMsg",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.msg), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["lds-spinner", { 'lds-spinner-small' : _ctx.size == 'small' }]),
      "aria-hidden": "true"
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1),
      _createElementVNode("div", null, null, -1)
    ]))], 2)
  ]))
}